// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Description-module--cls1--3blXG","cls2":"styles-Description-module--cls2--3HHq2 styles-Description-module--cls1--3blXG"};